"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getButtonSizes = void 0;
var getButtonSizes = function getButtonSizes(theme) {
  return {
    small: {
      padding: '0.5rem 2rem'
    },
    medium: {
      padding: '1.125rem 2rem'
    },
    large: {
      padding: '1.125rem 2rem'
    }
  };
};
exports.getButtonSizes = getButtonSizes;